<script>
import { mapGetters } from 'vuex'
// import Choices from 'choices.js'
import { required, email } from 'vuelidate/lib/validators'

import FeedbackModal from '@components/common/feedback-modal.vue'

import Translatable from '@src/mixins/translatable.js'

export default {
  components: {
    FeedbackModal,
  },
  mixins: [Translatable],
  validations: {
    name: {
      required,
    },
    email: {
      email,
      required,
    },
    // selectetSubject: {
    //   required,
    // },
    text: {
      required,
    },
  },
  data() {
    return {
      name: '',
      email: '',
      text: '',

      showFeedback: false,
      isOutside: false,
    }
  },
  computed: {
    ...mapGetters('translations', ['isTranslated']),
    isValidate() {
      return this.name && this.email && this.text
    },
  },
  // mounted() {
  //   this.choice = new Choices('#filter-dropdown', {
  //     silent: false,
  //     removeItems: false,
  //     searchEnabled: false,
  //     shouldSort: false,
  //     choices: [
  //       {
  //         label: this.getTranslatedContent(
  //           'CONTACT_US_get_in_touch_select_sales',
  //         ),
  //         value: 'sales-reservations',
  //       },
  //       {
  //         label: this.getTranslatedContent(
  //           'CONTACT_US_get_in_touch_select_marketing',
  //         ),
  //         value: 'marketing-partnerships',
  //       },
  //       {
  //         label: this.getTranslatedContent(
  //           'CONTACT_US_get_in_touch_select_technical',
  //         ),
  //         value: 'technical-issues',
  //       },
  //     ],
  //     classNames: {
  //       containerOuter: 'filter-dropdown',
  //       containerInner: 'inner-container',
  //       itemSelectable: 'selected-filter',
  //       openState: 'select-opened',
  //       listDropdown: 'filters-container',
  //       list: 'filters-list',
  //     },
  //   })

  //   this.$refs.filterDropdown.addEventListener('change', (data) => {
  //     this.selectetSubject = data.detail.value
  //   })
  // },
  // updated() {
  //   if (this.isTranslated) {
  //     this.setMailSubject()

  //     this.$store.commit('translations/SET_IS_TRANSLATED', false)
  //   }
  // },
  methods: {
    toggle(el) {
      this[el] = !this[el]
      document.body.style.overflow = this.showFeedback ? 'hidden' : ''
    },
    handleFocusOut() {
      this.isOutside = true
    },
    // setMailSubject() {
    //   this.choice.clearChoices()
    //   this.choice.setChoices([
    //     {
    //       label: this.getTranslatedContent(
    //         'CONTACT_US_get_in_touch_select_sales',
    //       ),
    //       value: 'sales-reservations',
    //       selected: true,
    //     },
    //     {
    //       label: this.getTranslatedContent(
    //         'CONTACT_US_get_in_touch_select_marketing',
    //       ),
    //       value: 'marketing-partnerships',
    //     },
    //     {
    //       label: this.getTranslatedContent(
    //         'CONTACT_US_get_in_touch_select_technical',
    //       ),
    //       value: 'technical-issues',
    //     },
    //   ])
    // },
    sendReview() {
      if (this.$v.$invalid) {
        this.isOutside = true
        this.$v.$touch()
      } else {
        const data = {
          name: this.name,
          email: this.email,
          subject: 'Prague CoolPass – Inquiry',
          text: this.text,
        }
        this.$store.dispatch('contactUs/sendContactForm', data)
        this.toggle('showFeedback')

        this.name = ''
        this.email = ''
        this.text = ''
        this.$v.$reset()
      }
    },
  },
}
</script>

<template>
  <div class="main-container">
    <FeedbackModal
      v-if="showFeedback"
      :text="getTranslatedContent('CONTACT_US_get_in_touch_modal')"
      @toggle="toggle"
    />
    <div class="description-container">
      <p
        class="description-title"
        v-html="getTranslatedContent('CONTACT_US_get_in_touch_form_title')"
      ></p>
      <p
        class="description-text"
        v-html="getTranslatedContent('CONTACT_US_get_in_touch_form_text')"
      ></p>
    </div>
    <div class="inputs-container">
      <div class="input-container">
        <label for="name" class="input-title"
          >{{ getTranslatedContent('CONTACT_US_form_name_field') }}
          <p v-if="$v.name.$error && !$v.name.required" class="error-message">{{
            getTranslatedContent('FORM_validate_required')
          }}</p>
          <input
            id="name"
            v-model="$v.name.$model"
            type="text"
            :placeholder="
              getTranslatedContent('CONTACT_US_form_name_placeholder')
            "
            :class="$v.name.$error ? 'error' : ''"
          />
        </label>
      </div>
      <div class="input-container">
        <label for="email" class="input-title"
          >{{ getTranslatedContent('CONTACT_US_form_email_field') }}
          <p
            v-if="$v.email.$error && !$v.email.required"
            class="error-message"
            >{{ getTranslatedContent('FORM_validate_required') }}</p
          >
          <p v-if="!$v.email.email && isOutside" class="error-message">{{
            getTranslatedContent('FORM_validate_email')
          }}</p>
          <input
            id="email"
            v-model="$v.email.$model"
            type="email"
            :placeholder="
              getTranslatedContent('CONTACT_US_form_email_placeholder')
            "
            :class="$v.email.$error && isOutside ? 'error' : ''"
            @focusout="handleFocusOut"
          />
        </label>
      </div>
    </div>
    <div class="input-review-container">
      <textarea
        v-model="$v.text.$model"
        class="input-review"
        cols="30"
        rows="10"
        :placeholder="getTranslatedContent('CONTACT_US_form_text_placeholder')"
        :class="$v.text.$error ? 'error' : ''"
      ></textarea>
    </div>
    <div class="button-container">
      <button
        class="button-send"
        :class="isValidate ? '' : 'disabled'"
        @click="sendReview"
      >
        {{ getTranslatedContent('CONTACT_US_form_send_btn') }}
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.main-container {
  background-color: $white;
  width: 1140px;
}

.description-container {
  width: 100%;
  margin-bottom: 40px;

  .description-title {
    font-family: Open Sans Bold, sans-serif;
    font-style: normal;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 22px;
    line-height: 130%;
    color: $dark-blue;
    padding-bottom: 15px;
  }

  .description-text {
    font-family: Open Sans, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 165%;
    color: $black;
    // opacity: 0.8;
  }
}

.inputs-container {
  display: flex;
  margin-bottom: 5px;

  .input-container {
    height: 76px;
    margin-bottom: 15px;
    flex: 1;
    min-width: 0;
    &:not(:last-child) {
      margin-right: 20px;
    }
  }

  .input-title {
    font-family: Open Sans Bold, sans-serif;
    font-style: normal;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 14px;
    line-height: 130%;
    color: $dark-blue;
  }

  p {
    display: inline;
    font-family: Open Sans Semibold, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    text-transform: lowercase;
    color: $orange;
  }
}

input {
  box-sizing: border-box;
  width: 100%;
  height: 48px;
  border: 1px solid $dark-gray;
  padding: 15px;
  margin-top: 10px;
  background: $white;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: rgba(37, 44, 62, 0.6);
}

.error {
  border: 1px solid $orange;
}

.input-review-container {
  width: 100%;
  height: 294px;
}

.input-review {
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  border: 1px solid $dark-gray;
  padding: 15px;
  background: $white;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  color: rgba(37, 44, 62, 0.6);
  resize: none;
}

::placeholder {
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  line-height: 130%;
  color: rgba(37, 44, 62, 0.6);
}

.button-container {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin: 20px 0 0 0;
}

.button-send {
  width: 245px;
  height: 48px;
  background: $dark-blue;
  border-radius: 5px;
  border: 1px solid $dark-blue;
  text-transform: uppercase;
  font-family: Open Sans Bold, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 130%;
  color: $white;

  &:hover {
    border: 1px solid $hover-blue;
    background: $hover-blue;
  }

  &.disabled {
    background: $gray;
    border: none;
    opacity: 0.4;
  }
}

.recaptcha {
  margin-right: 20px;
}

.error-message {
  display: inline;
  font-family: Open Sans Semibold;
  font-style: normal;
  font-size: 12px;
  line-height: 16px;
  text-transform: lowercase;
  color: $orange;
  margin-left: 10px;
}

.error {
  border: 1px solid $orange !important;
}

@media only screen and (max-width: $screen-width-xs) {
  .main-container {
    width: auto;
  }

  .description-container {
    width: 100%;
    margin: 10px 0 16px 0;

    .description-title {
      font-size: 18px;
    }

    .description-text {
      opacity: 1;
    }
  }

  .inputs-container {
    display: flex;
    flex-direction: column;

    .input-container {
      min-width: 100%;
      margin: 16px 0 0 0;
    }

    .input-title {
      font-family: Open Sans bold, sans-serif;
      font-weight: bold;
    }
  }

  .input-review-container {
    margin-top: 20px;
    width: 100%;
    height: 158px;
  }

  .button-container {
    flex-direction: column;
  }

  .button-send,
  .recaptcha {
    width: 100%;
  }

  .recaptcha {
    margin-bottom: 15px;
  }
}
</style>
